<template>
  <div class="evaluate">
    <div class="title">
      <span></span>
      <span>请选择撤销原因</span>
      <z-icon @click="close" color="#999999" class-prefix="zziconfont" name="close-text-o"></z-icon>
    </div>
    <div class="tip">
      请确保你与对方无纠纷，如还未收到退款或未收到货品，<b>对方仅承诺你撤销举报后再退款/发货，请谨慎操作，避免再次被骗！</b>
    </div>
    <div class="item">
      <div v-for="(item,index) in chooseItem" :key="index" @click="choose(item)" :class="{choosed:item.optionId == choosedItem.optionId}">{{item.optionTitle}}</div>
    </div>
    <div class="grow">
      <z-field
          type="textarea"
          v-model="causeText"
          placeholder="请填写详细原因"
          :maxlength="200"
          count-word
        />
    </div>
    <z-button :disabled="disabled" @click="submit" type="primary">提交</z-button>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Button, Dialog, Icon, Field } from '@zz-common/zz-ui'
import { revokeReport, getChooseItem } from '@api/resourceApi'
export default {
  name: 'RevokeReport',
  data() {
    return {
      causeText: '',
      chooseItem: [],
      choosedItem: {}
    }
  },
  inject: ['id', 'toUid'],
  components: {
    zButton: Button,
    zIcon: Icon,
    zField: Field
  },
  computed: {
    disabled() {
      if (this.choosedItem.optionStatus == '1') {
        return !this.causeText.length
      } else if (this.choosedItem.optionStatus == '0') {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    async submit() {
      await revokeReport({
        fromUid: this.toUid,
        type: '2',
        content: this.choosedItem.optionTitle + '-' + this.causeText
      })
      Dialog({
        title: '提交成功',
        message: '撤销举报提交成功，我们将在24小时内处理您的诉求，请留意【消息】-【通知互动】-【通知消息】中的信息。',
        closeOnClickOverlay: false
      }).then(() => {
        native.skipToUrl({
          targetUrl: location.href,
          needClose: '1'
        })
      }).catch(_type => {
        // on cancel
        // 回调参数为触发关闭弹窗的方式
      });
    },
    choose(item) {
      this.choosedItem = item
    }
  },
  created() {
    getChooseItem().then(res => {
      this.chooseItem = res.backReportOption
    })
  }
}
</script>
<style lang="less" scoped>
 @import 'index.less';
</style>